<template>
  <div class="wrapper">
    <div class="page_header">
      <div class="title_row">
        <h2 class="page_title">打工度假代辦服務應注意事項</h2>
        <a
          class="download_btn"
          href="/files/labor-holiday-work-agency-notice.pdf"
          download="打工度假代辦服務應注意事項.pdf"
        >
          文件下載 <DownloadOutlined />
        </a>
      </div>
      <div class="meta_row">
        <span class="meta_item">
          <BankOutlined />
          主管機關：勞動部
        </span>
        <span class="meta_item">
          <CalendarOutlined />
          公布日期：2026-03-04
        </span>
      </div>
    </div>

    <div class="content_body">
      <ol class="rule_list" role="list">
      <li class="rule_item">
        <span class="bullet" aria-hidden="true">●</span>
        <div class="rule_content">
          <p>
            一、勞動部（以下簡稱本部）為維護消費者接受打工度假代辦服務之權益，特訂定本注意事項。
          </p>
        </div>
      </li>

      <li class="rule_item">
        <span class="bullet" aria-hidden="true">●</span>
        <div class="rule_content">
          <p>
            二、本注意事項所稱主管機關：在中央為勞動部；在直轄市為直轄市政府；在縣（市）為縣（市）政府。
          </p>
        </div>
      </li>

      <li class="rule_item">
        <span class="bullet" aria-hidden="true">●</span>
        <div class="rule_content">
          <p>三、本注意事項所稱打工度假，指下列情形之一：</p>
          <p class="indent_1">
            (一) 我國外交部與其他國家簽署之青年打工度假計畫協議。
          </p>
          <p class="indent_1">
            (二) 美國國務院交流訪客計畫之暑期打工與旅遊計畫。
          </p>
          <p class="indent_1">(三) 其他經中央主管機關指定者。</p>
        </div>
      </li>

      <li class="rule_item">
        <span class="bullet" aria-hidden="true">●</span>
        <div class="rule_content">
          <p>
            四、本注意事項所稱打工度假代辦服務（以下簡稱代辦服務），指辦理打工度假計畫之說明及諮詢、申請相關簽證或資格、代辦申請計畫手續等未涉及就業服務之一般行政庶務業務。
          </p>
        </div>
      </li>

      <li class="rule_item">
        <span class="bullet" aria-hidden="true">●</span>
        <div class="rule_content">
          <p>
            五、本注意事項所稱打工度假代辦服務業者（以下簡稱代辦業者），指從事代辦服務之國內企業經營者。代辦業者，非經就業服務法之主管機關許可，不得從事該法第三十五條第一項所定之就業服務業務。
          </p>
        </div>
      </li>

      <li class="rule_item">
        <span class="bullet" aria-hidden="true">●</span>
        <div class="rule_content">
          <p>六、代辦業者辦理代辦服務，應遵行下列事項：</p>
          <p class="indent_1">
            (一)
            訂定簡章、計畫或申請代辦服務相關規定，並於代辦服務之服務網頁及其他明顯處所公告之。
          </p>
          <p class="indent_1">
            (二)
            前款簡章、計畫或申請代辦服務相關規定，應包括打工度假方式介紹、報名方式、代辦項目及各項目費用、申請異動須知、疑義處理機制、收費及退費規定、行前須知、海外緊急連絡窗口、不可歸責或不可抗力事項之處理作法、消費爭議處理及其他相關事項。
          </p>
          <p class="indent_1">
            (三) 應提供代辦服務契約及相關文件予消費者留存。
          </p>
          <p class="indent_1">
            (四)
            主動、據實告知消費者海外打工度假風險，並協助消費者事先充分瞭解申請前往之海外國家勞動法規，及提醒消費者另行投保適當之商業保險，且經消費者同意簽名確認。
          </p>
          <p class="indent_1">
            (五)
            必要時得向消費者說明，並符合個人資料保護法相關規定，要求消費者檢具外語能力、健康狀況或財力等相關證明文件。
          </p>
          <p class="indent_1">
            (六) 消費者為未成年人，應取得其法定代理人之書面同意。
          </p>
        </div>
      </li>

      <li class="rule_item">
        <span class="bullet" aria-hidden="true">●</span>
        <div class="rule_content">
          <p>
            七、代辦業者應依下列規定，於簡章、計畫或申請代辦服務相關規定中，明定退費基準：
          </p>
          <p class="indent_1">
            (一)
            因可歸責於代辦業者之事由，致打工度假活動無法成行者，代辦業者於知悉無法成行時，應即通知消費者並說明其事由，並應退還消費者已繳之全額費用；消費者若有其他損害，並應賠償，但代辦業者提供其他和解方案，經消費者同意者，不在此限。
          </p>
          <p class="indent_1">
            (二)
            因可歸責於消費者之事由，致打工度假活動無法成行者，代辦業者應提供已代繳必要費用之單據，經核實扣除後，將餘款依下列基準退還消費者：
          </p>
          <p class="indent_2">1.參與青年打工度假計畫者：</p>
          <p class="indent_3">
            (1)
            消費者於第一次繳費之次日起七日內申請退費，代辦業者應退還餘款百分之七十。
          </p>
          <p class="indent_3">
            (2)
            消費者於第一次繳費之次日起七日後至申請簽證前申請退費，代辦業者應退還餘款百分之五十。
          </p>
          <p class="indent_3">
            (3) 消費者因未能取得簽證而申請退費，代辦業者應退還餘款百分之四十。
          </p>
          <p class="indent_3">
            (4) 消費者於取得簽證後申請退費，代辦業者得不予退還。
          </p>
          <p class="indent_2">2.參與暑期打工與旅遊計畫者：</p>
          <p class="indent_3">
            (1)
            消費者於第一次繳費之次日起七日內申請退費，代辦業者應退還餘款百分之七十。
          </p>
          <p class="indent_3">
            (2)
            消費者於第一次繳費之次日起七日後至進行相關資格測驗前申請退費，代辦業者應退還餘款百分之五十。
          </p>
          <p class="indent_3">
            (3)
            消費者因未能取得工作資格而申請退費，代辦業者應退還餘款百分之四十。
          </p>
          <p class="indent_3">
            (4)
            消費者於取得相關工作資格或資格文件後申請退費，代辦業者得不予退還。
          </p>
          <p class="indent_2">
            3.其他經中央主管機關依第三點第三款指定之打工度假計畫，其退費基準，由中央主管機關另定之。
          </p>
          <p class="indent_1">
            (三)
            因天然或人為災害、戰亂、交通阻絕、邊境管制、政府命令或其他不可歸責於代辦業者及消費者之事由，致打工度假活動無法成行者，代辦業者應提供已代繳必要費用之單據，經核實扣除後，退還消費者全部餘款。
          </p>
        </div>
      </li>

      <li class="rule_item">
        <span class="bullet" aria-hidden="true">●</span>
        <div class="rule_content">
          <p>
            八、代辦業者應善盡審視資料真實性之義務，據實、充分揭露所掌握之打工職務內涵，提供消費者相關資訊之諮詢及輔導。
          </p>
        </div>
      </li>

      <li class="rule_item">
        <span class="bullet" aria-hidden="true">●</span>
        <div class="rule_content">
          <p>
            九、代辦業者應記錄消費者之姓名、地址、電話、國民身分證統一編號等必要資料，並保存至契約終止後一年。但其他法規另有規定者，從其規定。
          </p>
        </div>
      </li>

      <li class="rule_item">
        <span class="bullet" aria-hidden="true">●</span>
        <div class="rule_content">
          <p>
            前項資料代辦業者應盡善良管理人之注意義務，相關資料之蒐集、處理及利用等事項，應依個人資料保護法之規定為之。
          </p>
        </div>
      </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import {
  DownloadOutlined,
  BankOutlined,
  CalendarOutlined,
} from "@ant-design/icons-vue";

export default defineComponent({
  name: "FraudNoticeAgency",
  components: {
    DownloadOutlined,
    BankOutlined,
    CalendarOutlined,
  },
});
</script>

<style lang="scss" scoped>
.wrapper {
  text-align: left;
  margin: 20px 0 100px;
}

.page_header {
  border-bottom: 1px solid var(--border, rgba(226, 232, 240, 1));
  padding-bottom: 20px;
  margin-bottom: 24px;

  .title_row {
    @include flex_between();
    margin-bottom: 16px;
    gap: 16px;
    @include xs {
      flex-direction: column;
      align-items: flex-start;
    }

    .page_title {
      @include flex_center();
      font-size: 36px;
      font-weight: 500;
      font-family: "Noto Sans TC";
      color: #000000d9;
      :deep(svg) {
        margin-right: 10px;
        color: $main_color;
      }
    }

    .download_btn {
      @include flex_center();
      background-color: $main_color;
      color: #ffffff;
      padding: 16px 40px;
      font-size: 16px;
      font-weight: 700;
      font-family: "Noto Sans";
      white-space: nowrap;
      :deep(svg) {
        margin-left: 8px;
      }
      &:hover {
        opacity: 0.85;
      }
    }
  }

  .meta_row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 32px;

    .meta_item {
      @include flex_center();
      font-size: 14px;
      font-family: "Noto Sans TC";
      font-weight: 500;
      color: #64748b;
      :deep(svg) {
        margin-right: 8px;
      }
    }
  }
}

.content_body {
  max-width: 1024px;

  .rule_item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;

    .bullet {
      flex-shrink: 0;
      color: $main_color;
      font-size: 10px;
      line-height: 28.8px;
      margin-right: 12px;
    }

    .rule_content {
      flex: 1;

      p {
        font-size: 16px;
        line-height: 1.8;
        color: #000000d9;
        margin-bottom: 4px;

        &.indent_1 {
          margin-left: 24px;
        }
        &.indent_2 {
          margin-left: 48px;
        }
        &.indent_3 {
          margin-left: 72px;
        }
      }
    }
  }
}
</style>
